import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@mui/lab';
import { AlertTitle } from '@mui/material';

function ErrorShower({ erroredFields, fields }) {
  const systemErrors = useMemo(
    () => (erroredFields.error_data ? [{
      title: null,
      text: erroredFields.error_data[0].messages.join(', '),
      key: 'systemErrors',
    }] : []),
    [erroredFields.error_data],
  );
  const nonFieldErrors = useMemo(
    () => (erroredFields.non_field_errors ? [{
      title: null,
      text: erroredFields.non_field_errors.join(', '),
      key: 'nonFieldErrors',
    }] : []),
    [erroredFields.non_field_errors],
  );
  const tablePartFieldErrors = useMemo(
    () => Object.keys(erroredFields)
      .filter((fieldName) => fields[fieldName] && fields[fieldName].child && fields[fieldName].child.children)
      .reduce((R, fieldName) => {
        const ff = fields[fieldName];
        return [
          ...R,
          ...erroredFields[fieldName]
            .reduce((R2, suberr, numStr) => ([
              ...R2,
              ...Object.keys(suberr)
                .filter((field2) => field2 in ff.child.children)
                .map((field2) => ({
                  title: `${ff.label} строка № ${numStr + 1}  ${ff.child.children[field2].label}`,
                  text: suberr[field2].join(', '),
                  key: `${fieldName}.${field2}`,
                })),
            ]), []),
        ];
      }, []),
    [erroredFields, fields],
  );

  const fieldsError = useMemo(
    () => Object.keys(erroredFields)
      .filter((f) => fields[f] && erroredFields[f].filter((ef) => typeof ef === 'string').length)
      .map((f) => ({
        title: fields[f].label,
        text: erroredFields[f].join(', '),
        key: f,
      })),
    [erroredFields, fields],
  );

  const allErrors = useMemo(
    () => [
      ...systemErrors,
      ...nonFieldErrors,
      ...tablePartFieldErrors,
      ...fieldsError,
    ],
    [fieldsError, nonFieldErrors, systemErrors, tablePartFieldErrors],
  );

  return (
    <div>
      {allErrors.map((err) => (
        <Alert key={err.key} severity="error">
          {err.title && (
          <AlertTitle>{err.title}</AlertTitle>
          )}
          {err.text}
        </Alert>
      ))}
    </div>
  );
}

ErrorShower.propTypes = {
  erroredFields: PropTypes.shape({
    error_data: PropTypes.arrayOf(PropTypes.shape({
      messages: PropTypes.arrayOf(PropTypes.string),
    })),
    non_field_errors: PropTypes.arrayOf(PropTypes.string),
  }),
  fields: PropTypes.shape({}).isRequired,
};

ErrorShower.defaultProps = {
  erroredFields: {},
};

export default ErrorShower;
